import React from 'react';
import { Button, Checkbox } from '../../../base';

/** 세션 승인 모드
 *  Default: 매번 확인, ByPass: 이 세션 승인 우회, Autopilot: 승인 우회 */
export type SessionApprovalMode = 'Default' | 'ByPass' | 'Autopilot';

interface ApprovalActionsProps {
  onRespond: (approved: boolean, sessionMode?: SessionApprovalMode) => void;
  answered?: boolean;
  approvedResult?: boolean;
  approveLabel?: string;
  rejectLabel?: string;
  showAlways?: boolean;
}

/** HITL 승인(request_approval) */
export const ApprovalActions: React.FC<ApprovalActionsProps> = ({
  onRespond,
  answered = false,
  approvedResult,
  approveLabel = '승인',
  rejectLabel = '거절',
  showAlways = true,
}) => {
  const [submitted, setSubmitted] = React.useState(false);
  const [alwaysApprove, setAlwaysApprove] = React.useState(false);
  const disabled = answered || submitted;

  const handle = (approved: boolean) => {
    if (disabled) return;
    setSubmitted(true);
    // 승인 + '이 채팅에서 항상 승인' 체크 시 세션 모드를 Autopilot으로 전달 
    onRespond(approved, approved && alwaysApprove ? 'Autopilot' : undefined);
  };

  if (answered) {
    return <div className="hitl-approval-status">{approvedResult ? '승인됨' : '거절됨'}</div>;
  }

  return (
    <div className="hitl-approval">
      <div className="hitl-approval-actions">
        <Button
          size="large"
          variant="ghost"
          disabled={disabled}
          onClick={() => {
            handle(false);
          }}
        >
          {rejectLabel}
        </Button>
        <Button
          size="large"
          variant="primary"
          disabled={disabled}
          onClick={() => {
            handle(true);
          }}
        >
          {approveLabel}
        </Button>
      </div>
      {showAlways && (
        <Checkbox
          className="hitl-approval-always"
          checked={alwaysApprove}
          disabled={disabled}
          onChange={(e) => {
            setAlwaysApprove(e.target.checked);
          }}
        >
          이 채팅에서 항상 승인
        </Checkbox>
      )}
    </div>
  );
};
